import type { PoolPlacement, PoolApplication, PoolClimate } from '@/api/calculators/types';

export const CLIMATE_OPTIONS: Array<{ value: PoolClimate; label: string }> = [
  { value: 'hot_dry', label: 'Hot & Dry (Ahmedabad, Jaipur, Jodhpur)' },
  { value: 'warm_humid', label: 'Warm & Humid (Mumbai, Chennai, Goa)' },
  { value: 'composite', label: 'Composite (Delhi NCR, Lucknow, Bhopal)' },
  { value: 'temperate', label: 'Temperate (Bangalore, Pune, Hyderabad)' },
  { value: 'cold', label: 'Cold (Chandigarh, Shimla, Dehradun)' },
  { value: 'extreme_cold', label: 'Extreme Cold (Leh, Manali, Srinagar)' },
];

export const PLACEMENT_OPTIONS: Array<{ value: PoolPlacement; label: string }> = [
  { value: 'outdoor', label: 'Outdoor' },
  { value: 'indoor', label: 'Indoor' },
];

export const APPLICATION_OPTIONS: Array<{ value: PoolApplication; label: string }> = [
  { value: 'residential', label: 'Residential' },
  { value: 'hotel', label: 'Hotel / resort' },
  { value: 'club', label: 'Club' },
  { value: 'academy', label: 'Academy' },
  { value: 'commercial', label: 'Commercial' },
];

export const HEAT_TIME_OPTIONS: Array<{ value: 24 | 36 | 48; label: string }> = [
  { value: 24, label: 'Under 24 hr' },
  { value: 36, label: 'Under 36 hr' },
  { value: 48, label: 'Under 48 hr' },
];

export const TARGET_TEMP_OPTIONS: ReadonlyArray<26 | 27 | 28 | 29 | 30> = [
  26, 27, 28, 29, 30,
];

export const POOL_MODEL_OPTIONS: ReadonlyArray<string> = [
  'ST-HP-14',
  'ST-HP-SP-27',
  'ST-HP-SP-55',
  'ST-HP-SP-80',
  'ST-HP-SP-100',
  'ST-HP-SP-125',
  'ST-HP-SP-150',
];

// ─── Helpers ────────────────────────────────────────────────────────────────

export const fmt = (n: number | null | undefined, d = 0): string => {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  return Number(n).toLocaleString('en-IN', {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });
};

/** Indian-currency formatter — Cr / L abbreviated. */
export const rs = (n: number | null | undefined): string => {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  if (n >= 1_00_00_000) return '₹' + fmt(n / 1_00_00_000, 2) + ' Cr';
  if (n >= 1_00_000) return '₹' + fmt(n / 1_00_000, 2) + ' L';
  return '₹' + fmt(Math.round(n), 0);
};
